import CollectionScreen from './CollectionScreen'

export default CollectionScreen
